var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-alerts-wrapper"},_vm._l((_vm.alerts),function(alert){return _c('transition',{key:alert.id,attrs:{"appear":"","name":"fade"}},[_c('AlertTooltip',{attrs:{"alert":alert}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }